import gql from 'graphql-tag';
import { shipmentListFragment } from '../../../../graphql/query/shipmentList';

export default gql`
  query LazadaShipmentList(

    $pick_up_date: String
    $last_update: String
    $order_by: String
    $order_type: String
    $page_number: Int
    $commodity_name: String

  ) {
    shipmentList(
      commodity_name: $commodity_name
      shipment_prefix: "GLZ"
      show_data: 30
      page_number: $page_number
      order_by: $order_by
      order_type: $order_type
      pick_up_date: $pick_up_date
      last_update: $last_update
    ) {
      shipment {
        ...shipmentFields
      }

      total_page
    }
  }

  ${shipmentListFragment}
`;
